import type { MatchOver } from "@mk/shared";
import { messages } from "../../i18n/index.ts";
import { formatNumber } from "../../lib/edition.ts";

type DuelResultTextInput = Pick<MatchOver, "winnerId" | "reason" | "you" | "opponent">;

function seconds(milliseconds: number): string {
  const value = milliseconds / 1000;
  return messages.duel.seconds(
    formatNumber(value, { minimumFractionDigits: Number.isInteger(value) ? 0 : 1, maximumFractionDigits: 1 }),
  );
}

/** Maç sonucunu, bu ekrana bakan oyuncunun açısından açıklar. */
export function duelResultText(result: DuelResultTextInput, meId: string | undefined): string {
  const opponent = result.opponent.user.username;
  const won = result.winnerId === meId;

  switch (result.reason) {
    case "first-solver":
      return won
        ? messages.duel.firstSolverWin
        : messages.duel.firstSolverLoss(opponent);
    case "forfeit":
      return won
        ? messages.duel.forfeitWin(opponent)
        : messages.duel.forfeitLoss;
    case "only-solver":
      return result.you.solved
        ? messages.duel.onlyYou
        : messages.duel.onlyOpponent(opponent);
    case "fewer-guesses":
      return won
        ? messages.duel.fewerWin(result.you.attempts, opponent, result.opponent.attempts)
        : messages.duel.fewerLoss(opponent, result.opponent.attempts, result.you.attempts);
    /* Eski maçlar için duruyor; yeni maçlarda süre kazanan belirlemiyor. */
    case "faster": {
      const yourTime = result.you.solveDurationMs ?? 0;
      const opponentTime = result.opponent.solveDurationMs ?? 0;
      const difference = seconds(Math.abs(yourTime - opponentTime));
      return won
        ? messages.duel.fasterWin(result.you.attempts, difference)
        : messages.duel.fasterLoss(result.you.attempts, opponent, difference);
    }
    case "draw-none-solved":
      return messages.duel.noneSolved;
    case "draw-identical":
      return messages.duel.identical(result.you.attempts);
  }
}
